import * as types from '../types'

/**
 * 文章数据
 * @type {Object}
 */
const state = {
    list: [],
    detail: {
        article: {
            title: ''
        },
        detail: []
    }
}

const getters = {

}

const mutations = {
    [types.CHANGE_ARTICLE_LIST] (state, params) {
        state.list = params
    },

    [types.AJAX_ARTICLE_LIST] (state, params) {
        state.list = state.list.concat(params)
    },

    [types.CHANGE_ARTICLE_DETAIL] (state, params) {
        state.detail = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/article.js